const customStyles = {
  control: (provided: any) => ({
    ...provided,
    background: '#f5f8fa',
    borderRadius: '5px',
    zIndex: 98,
    minWidth: 120,
    fontSize: '1.1rem',
    fontWeight: 500,
    minHeight: '44px',
    maxHeight: '44px',
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    maxHeight: '38px',
    overflow: 'hidden',
    flexWrap: 'nowrap',
    padding: '2px 8px',
  }),
  multiValue: (provided: any) => ({
    ...provided,
    maxWidth: 'fit-content',
    margin: '2px',
  }),
  multiValueLabel: (provided: any) => ({
    ...provided,
    fontSize: '0.95rem',
    padding: '2px 6px',
  }),
  multiValueRemove: (provided: any) => ({
    ...provided,
    padding: '0 4px',
  }),
  indicatorSeparator: (_: any) => ({
    display: 'none',
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
  }),
  option: (styles: any) => {
    return {
      ...styles,
      fontSize: '1.1rem',
    }
  },
  menu: (base: any) => ({...base, zIndex: 9999}),
  menuPortal: (base: any) => ({...base, zIndex: 9999}),
  singleValue: (provided: any) => ({...provided, background: '#f5f8fa', fontSize: '1.1rem', fontWeight: 500}),
  placeholder: (defaultStyles: any) => ({...defaultStyles, background: '#f5f8fa', fontSize: '1.1rem', fontWeight: 500}),
}

export default customStyles
